import { render, staticRenderFns } from "./tcvideo.vue?vue&type=template&id=24193d74&scoped=true"
import script from "./tcvideo.vue?vue&type=script&lang=js"
export * from "./tcvideo.vue?vue&type=script&lang=js"
import style0 from "./tcvideo.vue?vue&type=style&index=0&id=24193d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24193d74",
  null
  
)

export default component.exports